import "../css/nav.css"
import { Icon } from "@iconify/react";
import useGenStore from "../store/store";
import { useNavigate } from "react-router-dom";
import Aos from "aos";

function Nav(){
    const setMenuActive=useGenStore((s)=>s.setMenuActive)
    const navigate = useNavigate()
    const showFonMenu =()=>{
        console.log("allo")
         setMenuActive(true)
    }
    const handleCall = () => {
  window.location.href = "tel:+13602974057";
};
const toHome =()=>{
    navigate("/")
}

    return(
        <div className="navWrap">
            <div className="navPlacer">
                <div className="navLogo" onClick={()=>toHome()}>
                    <span className="thickLogo">McCanna <span className="slimLogo">Law, PLLC</span></span>
                </div>
                <div className="navLinks">
                    <div className="navLink navLinkactive">
                        <a href="/">Home</a>
                    </div>
                    <div className="navLink">
                        <a href="/practice-areas">Practice Areas</a>
                    </div>
                    <div className="navLink">
                        <a href="/services">Services</a>
                    </div>
                    <div className="navLink">
                        <a href="/about">About Me</a>
                    </div>
                    <div className="navLink">
                        <a href="/contact">Contact</a>
                    </div>
                </div>
                <div className="navComs">
                    <div className="navFonHam" onClick={()=>showFonMenu()}>
                       <Icon className="faIcon" icon="solar:hamburger-menu-broken"/>
                    </div>
                    <div className="navFonIcon" onClick={()=>handleCall()}>
                       <Icon className="faIcon" icon="solar:phone-bold"/>
                    </div>
                    <div className="navFonNumber" onClick={()=>handleCall()}>
                       <p>(360) 297 4057</p> 
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Nav;